import { render } from "./CTAArea.vue?vue&type=template&id=1280aa7e"
import script from "./CTAArea.vue?vue&type=script&lang=js"
export * from "./CTAArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__